import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { ServicesListComponent } from './components/services-list/services-list.component';
import { WebappsListComponent } from './components/webapps-list/webapps-list.component';

@NgModule({
  declarations: [
    ServicesListComponent,
    WebappsListComponent
  ],
  imports: [    
    NgSelectModule,
    FormsModule,
    MatExpansionModule,
    CommonModule,
    RouterModule,
    SharedModule
  ] 
})
export class AzureTestServerModule { }
